import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
};

// const labels = ["January", "February", "March", "April", "May", "June", "July"];

export default function App({
  labels,
  dataset1,
  label1,
  dataset2,
  label2,
}: any) {
  const data = {
    labels,
    datasets: [
      {
        label: label1,
        data: dataset1,
        backgroundColor: "#FF8372",
      },
      {
        label: label2,
        data: dataset2,
        backgroundColor: "#00ADC6",
      },
    ],
  };
  return <Bar options={options} data={data} />;
}
